// extracted by mini-css-extract-plugin
export default {"flexContainer":"DeviceEntry_flexContainer__eCNmq","flexItemRight":"DeviceEntry_flexItemRight__Ck692"};